module.exports = __webpack_public_path__ + "img/bnapay.9662cdbd.png";